import React, { memo } from "react";
import { Table } from "antd";
import TableWrapper from "./components/TableWrapper";
import { formatPhoneNumber } from "../../utils/phoneNumber";

const columns = [
  {
    title: "Name",
    dataIndex: "driverName",
    key: "driverName",
    render: text => text ?? "N/A",
  },
  {
    title: "Phone Number",
    dataIndex: "driverPhoneNumber",
    key: "driverPhoneNumber",
    render: (text, record) =>
      text ? formatPhoneNumber(text, record.driverPhoneExtension) : "N/A",
  },
  {
    title: "Transporter Company",
    dataIndex: "transporterName",
    key: "transporterName",
    render: text => text ?? "N/A",
  },
];

export default memo(function DriverTable({ data }) {
  return (
    <TableWrapper title="Driver">
      <Table
        pagination={false}
        dataSource={data}
        columns={columns}
        style={{
          marginBottom: 32,
        }}
      />
    </TableWrapper>
  );
});
